import CompanyDataRowSkeletons from "@/components/molecules/company/detail/overview/basic/CompanyDataRowSkeletons";

type CompanyDetailSubHeaderProps = {
  title: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  skeletonCount?: number;
};

const CompanyDetailSubHeader = ({ title, isLoading, children, skeletonCount = 1 }: CompanyDetailSubHeaderProps) => {
  return (
    <div>
      <h4 className={"mb-0.5 text-xs font-medium text-quinary"}>{title}</h4>
      {isLoading ? <CompanyDataRowSkeletons count={skeletonCount} /> : children}
    </div>
  );
};

export default CompanyDetailSubHeader;
